'use strict';
import request from '@/utils/request';
class FileserverService{
    static list(query){
        return request({
            url:'/fileserver/showfilessaved',
            method:'get',
            params:query
        })
    }
    static showprojectasadmin(query){
        return request({
            url:'/fileserver/showprojectasadmin',
            method:'get',
            params:query
        })
    }
    static projectexist(query){
        return request({
            url:'/fileserver/projectexist',
            method:'get',
            params:query
        })
    }
    static deletefile(query,data){
        return request({
            url:'/fileserver/deletefile',
            method:'post',
            params:query,
            data
        })
    }
    static uploadfiles(query,data){
        return request({
            url:'/fileserver/uploadfiles',
            method:'post',
            params:query,
            data
        })
    }
}

export default FileserverService
